export const ZALO_LINK = "https://zalo.me/0838598518";
export const FACE_LINK = "https://www.facebook.com/ha.quyen.554224";
